import m from 'mithril'

export default {
  view: vnode => {
    const Protestdemonstration = require('./Protestdemonstration.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-24-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>     
        <figure className="log-book-figure">
        <img src={Protestdemonstration} className="log-book-img" /> 
            <figcaption className="log-book-figcaption">
            I start-60'erne er der i Danmark fire protestdemonstrationer mod atomvåben.   
            </figcaption>
          </figure>   
          <h3 className="log-book-text mod-h3">Gallup-meningsmåling, 1959</h3> 
          <p className="log-book-text">Skal Danmark have atomraketter?</p> 
          <p className="log-book-text">Ja: 12 %</p> 
          <p className="log-book-text">Nej: 49 %</p> 
          <p className="log-book-text">Ved ikke: 39 %</p> 
          
        </div>
      </div>
    )
  }
}
